"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _calciteComponentsReact = require("@esri/calcite-components-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } // Third-party components (buttons, icons, etc.)
var CheckBox = function CheckBox(_ref) {
  var allItemsSelected = _ref.allItemsSelected,
    itemIsSelected = _ref.itemIsSelected,
    onCalciteCheckboxChange = _ref.onCalciteCheckboxChange;
  var checkedObj = {};
  if (allItemsSelected || itemIsSelected) {
    checkedObj.checked = true;
  }

  // This method of indicating whether or not checkbox is checked is necessary for how CalciteCheckbox operates.  Essentially, it does not work to specify a simple boolean for the 'checked' prop passed to CalciteCheckbox.  One must add a 'checked' value of true and no value at all if false.  Adding checked={{truthy value} || undefined} will not work.  Rather there must simply be an absense of a value if box should not be checked.

  return /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteCheckbox, _extends({}, checkedObj, {
    onCalciteCheckboxChange: onCalciteCheckboxChange
  }));
};
var _default = CheckBox;
exports.default = _default;